












// vendor
import { defineComponent, PropType, ref, onMounted, onBeforeUnmount, set, watch } from "@vue/composition-api";
// project
import { generateGUID } from "@/utils/guid";
// local
import { SARTPlayer } from "../ts/SARTPlayer";
import { SARTParams } from "../ts/types/SARTParams";
import { SARTOutput } from "../ts/types/SARTOutput";
import DebugOverlay from "./debug-overlay.vue";

export default defineComponent({

	emits:[ "end" ],
	props:{
		parameters:{
			type:Object as PropType<SARTParams>,
			required:true
		}
	},
	setup(props, context){

		const displayValue = ref<number>();
		const player:SARTPlayer = new SARTPlayer(props.parameters);

		const onEnd = (data:SARTOutput) => {
			context.emit("end", data);
		};

		const onValue = (v:number|undefined) => {
			displayValue.value = v;
		};

		const start = () => {
			player.start();
		};

		onMounted(() => {
			start();
		});

		onBeforeUnmount(() => {
			player.dispose();
		});

		player.on("end", onEnd);
		player.on("value", onValue);

		return {
			start,
			displayValue
		};

	}

});



